export default __webpack_public_path__ + "static/media/icon_instructions.93cac2b9.svg";